import { InfoIcon } from "assets/icons";
import cn from "classnames";
import { ReactNode } from "react";

import styles from "./NoticeBanner.module.scss";

interface NoticeBannerProps {
  children: ReactNode;
  variant?: "info" | "warning";
  className?: string;
}

const NoticeBanner = ({
  children,
  variant = "info",
  className
}: NoticeBannerProps) => {
  return (
    <div className={cn(styles.banner, styles[`banner--${variant}`], className)}>
      <InfoIcon className={styles.banner__icon} />
      <div className={styles.banner__text}>{children}</div>
    </div>
  );
};

export default NoticeBanner;
